<template>
  <div class="box-container">
    <div class="box">
      <p>Londres, 1843</p>
      <p>Ma chère et tendre,</p>
      <p>
        Vous ne connaissez pas encore mon identité,
        <br />pourtant je me languis de vous serrer dans mes bras.
        <br />Ceci est mon cinquième courrier. Comme dans les
        <br />précédents, un habile procédé devrait vous permettre
        <br />de trouver une lettre de mon patronyme, aujourd'hui,
        <br />la dernière. J'ai confiance, votre intelligence doit être
        <br />l'égal de votre élégance..
        <br />
      </p>
      <p>
        Nous sommes maintenant prêts à nous rencontrer.
        <br />Je ne suis pas loin de vous, j'arrive. Peut-être
        <br />même suis-je déjà en bas de chez vous.
      </p>
      <p>
        Nous allons bientôt nous retrouver. Votre fidèle
        <br />admirateur.
      </p>
      <p
        style="color: rgb(1,1,1,0); text-align: center; line-height: 30px; cursor: zoom-in"
      >331 723 646 822 561 615 117 442 245 124</p>
      <p style="text-align: right">
        _&nbsp;_&nbsp;_&nbsp;_&nbsp;
        <span class="circle">Q</span>
        <span class="question">?</span>
      </p>
      <div class="hints">
        <div v-for="(hint, index) in reduceList" :key="index">
          <button
            :class="getClass(hint, index)"
            @click="display(hint.id)"
            :disabled="getClass(hint, index) === 'inactive' "
          >🕯 #{{index + 1}}</button>
        </div>
      </div>
      <div v-for="(hint, index) in reduceList" :key="index">
        <hint
          v-if="hint.display"
          :content="hint.content"
          :index="index"
          :read="hint.read"
          @close="closeHints()"
          @continue="increment(hint.id)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Hint from "../Gipsy/Hint";

export default {
  name: "Box",
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "dayOne")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Great+Vibes&display=swap");
p {
  font-family: "Libre Caslon Text", serif;
}
.box-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.box {
  overflow: scroll;
  padding: 2% 5%;
  height: 90%;
  font-family: "Great Vibes", cursive;
  font-size: 1.8vw;
  position: absolute;
  white-space: nowrap;
}
.box img {
  height: 60px;
  -webkit-transform: rotate(80deg);
  position: relative;
  left: 92%;
  bottom: 30%;
}
.caps {
  color: rgba(0, 0, 0, 0.7);
  float: left;
  font-size: 110px;
  line-height: 0.8em;
  padding-right: 12px;
  position: relative;
  top: 8px;
}
.question {
  font-family: "Permanent Marker", cursive;
  color: red;
  font-size: 55px;
  line-height: 20px;
}
.circle {
  border: 5px solid red;
  padding: 10px;
  border-radius: 50%;
}
.hints {
  margin-bottom: 3%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>